import { BankAccountResourceModel } from '@/modules/bank-account/models/bank-account-resource.model'
import { RoleCollectionModel } from '@/modules/role/models/role-collection.model'
import { Data } from '@/modules/shared/models/data'

export enum WalletType {
  USER = 'user',
  WRITER = 'writer'
}

export enum WalletIncreaseType {
  INC = 'inc',
  DEC = 'dec'
}

export interface WalletIndexResourceModel {
  id: number
  username: WalletType
  displayname: string
  avatar: string
  created_at: string
  roles: RoleCollectionModel[]
  wallet_amount: number
  writer_wallet_amount: number
  bank_account: BankAccountResourceModel
}

export type WalletIndexResourceType = Data<WalletIndexResourceModel>